import R from 'ramda'
import {
  propAsJson,
  stringifyBody,
  hasBody
} from 'pages/widgets/mapping/common-functions'

const CALL_ENDPOINT_ACTION_TYPE = 'CALL_ENDPOINT'
const CALL_ENDPOINT_DISPLAY_TYPE = 'Call endpoint'

const isCallEndpointFormAction = R.propEq('type', CALL_ENDPOINT_DISPLAY_TYPE)

const convertCallEndpointFormActionToWidgetAction = R.applySpec({
  type: R.always(CALL_ENDPOINT_ACTION_TYPE),
  url: R.prop('url'),
  method: R.prop('method'),
  headers: propAsJson('headers'),
  body: R.when(hasBody, stringifyBody),
  form: propAsJson('form'),
  query: propAsJson('query'),
  timeout: propAsJson('timeout'),
  retry: propAsJson('retry')
})

export { isCallEndpointFormAction, convertCallEndpointFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/call-endpoint.js